import { type Key, useCallback, useState } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';

import { getScrollParent } from '@/components/ui/sortable-tree/get-scroll-parent';

const ROW_ESTIMATE_PX = 36;
const ROW_OVERSCAN = 12;

interface UseVirtualRowsOptions {
  count: number;
  getItemKey: (index: number) => Key;
  gap?: number;
}

export function useVirtualRows({ count, getItemKey, gap }: UseVirtualRowsOptions) {
  const [scrollElement, setScrollElement] = useState<HTMLElement | null>(null);

  const listRef = useCallback((node: HTMLElement | null) => {
    setScrollElement(node ? getScrollParent(node) : null);
  }, []);

  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => scrollElement,
    estimateSize: () => ROW_ESTIMATE_PX,
    overscan: ROW_OVERSCAN,
    getItemKey,
    gap,
  });

  return { listRef, virtualizer };
}
